import React from 'react';
import { Card, Button, Space, Modal, Typography } from 'antd';
import { 
    LogoutOutlined, 
    SearchOutlined, 
    ExclamationCircleOutlined 
} from '@ant-design/icons';
import { useChat } from '../context/ChatContext';
import ChatHeader from '../components/Chat/ChatHeader';
import MessageList from '../components/Chat/MessageList';
import MessageInput from '../components/Chat/MessageInput';
import { Navigate } from 'react-router-dom';

const { Text } = Typography;

const Chat = () => {
    const { 
        partnerInfo, messages, partnerTyping, partnerLeft, sendMessage, 
        sendTyping, leave, nextPartner, socketId, darkMode 
    } = useChat();

    const handleNextPartner = () => {
        if (partnerLeft) {
            nextPartner();
            return;
        }

        Modal.confirm({
            title: 'Փոխել զրուցակցին',
            icon: <ExclamationCircleOutlined style={{ color: '#1677ff' }} />,
            content: 'Վստա՞հ եք, որ ցանկանում եք ավարտել այս զրույցը և գտնել նոր զրուցակից:',
            okText: 'Այո',
            cancelText: 'Ոչ',
            onOk() {
                nextPartner();
            },
        });
    };

    const handleBackToMenu = () => {
        Modal.confirm({
            title: 'Գլխավոր մենյու',
            icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
            content: 'Վստա՞հ եք, որ ցանկանում եք վերադառնալ գլխավոր մենյու:',
            okText: 'Այո',
            cancelText: 'Ոչ',
            onOk() {
                leave();
            },
        });
    };

    if (!partnerInfo && messages.length === 0) {
        return <Navigate to="/" />;
    }

    return (
        <div style={{ 
            maxWidth: 600, 
            margin: '0 auto', 
            height: '100dvh', 
            display: 'flex', 
            flexDirection: 'column',
            overflow: 'hidden'
        }}>
            <Card 
                title={<ChatHeader 
                    partnerInfo={partnerInfo} 
                    onLeave={leave} 
                    onNext={handleNextPartner}
                    partnerLeft={partnerLeft}
                />}
                styles={{ 
                    body: { 
                        flex: 1, 
                        overflow: 'hidden', 
                        display: 'flex', 
                        flexDirection: 'column',
                        padding: '0 10px',
                        background: darkMode ? '#1f1f1f' : '#ffffff'
                    },
                    header: {
                        padding: '10px 15px',
                        borderBottom: darkMode ? '1px solid #303030' : '1px solid #f0f0f0'
                    }
                }}
                style={{ 
                    flex: 1, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    borderRadius: 0,
                    overflow: 'hidden',
                    border: 'none'
                }}
            >
                <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <MessageList 
                        messages={messages} 
                        partnerTyping={partnerTyping} 
                        socketId={socketId} 
                    />
                </div>
                
                {partnerLeft ? (
                    <div style={{ 
                        padding: '15px', 
                        textAlign: 'center', 
                        background: darkMode ? '#141414' : '#fafafa',
                        borderRadius: 12,
                        margin: '10px 0'
                    }}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Text strong style={{ color: '#ff4d4f' }}>Զրուցակիցը դուրս եկավ</Text>
                            <Space size="middle" style={{ marginTop: 10 }}>
                                <Button 
                                    type="primary" 
                                    icon={<SearchOutlined />} 
                                    onClick={handleNextPartner}
                                    style={{ borderRadius: 8 }}
                                >
                                    Նոր որոնում
                                </Button>
                                <Button 
                                    icon={<LogoutOutlined />} 
                                    onClick={handleBackToMenu}
                                    style={{ borderRadius: 8 }}
                                >
                                    Գլխավոր մենյու
                                </Button>
                            </Space>
                        </Space>
                    </div>
                ) : (
                    <div style={{ padding: '10px 0', display: 'flex', gap: 10, alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>
                            <MessageInput 
                                onSendMessage={sendMessage} 
                                onTyping={sendTyping} 
                            />
                        </div>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default Chat;